<div>
    @let planning = realisation.planning;
    @let project = realisation.project;
    @let planningHas = realisation.planning_has;
    @let userPlanning = realisation.user_planning;
    @let isTransport = planning?.is_transport;

    <div class="head section bg-white">
        <div class="container-xl">
            <div class="d-flex flex-wrap gap-3">
                <div class="realisation-heading__title flex-shrink-1">
                    <h1>
                        Project
                        <strong>{{ realisation | realisationAfasProjectIdPipe }}</strong>
                    </h1>
                    <h2>
                        {{ project?.name ?? planning?.project?.name ?? userPlanning?.project?.name }}
                    </h2>
                </div>
                @if (planning?.id) {
                    <div
                        class="realisation-heading__actions d-grid flex-grow-1 flex-shrink-0 gap-2 align-self-start mw-100">
                        @if (environment.weekScheduleComponent === 'planning') {
                            <button
                                class="w-100"
                                (click)="openOrderForm(planning.id)"
                                mat-raised-button
                                color="primary">
                                Opdrachtformulier
                            </button>
                        }
                        @if (Features.DayreportsSave | hasFeature) {
                            <button
                                class="planning-button w-100"
                                [routerLink]="`/dagrapport/${planning.id}`"
                                mat-raised-button
                                color="primary">
                                Dagrapport
                            </button>
                        }
                    </div>
                }
            </div>
            <hr />

            <div class="data">
                <div class="data-row">
                    <div class="data-cell">Datum</div>
                    <div class="data-cell strong">{{ date | date: 'd MMMM yyyy' }}</div>
                </div>
                <div class="data-row">
                    <div class="data-cell">Tijd</div>
                    <div class="data-cell strong">
                        {{ realisation.begindate | date: 'HH:mm' }} - {{ realisation.enddate | date: 'HH:mm' }}
                    </div>
                </div>
                @let tijdstipAsfalt = planning | planningFieldValue: 'tijdstip_asfalt_gereed';
                @if (tijdstipAsfalt) {
                    <div class="data-row">
                        <div class="data-cell">Asfalt gereed</div>
                        <div class="data-cell strong">
                            {{ tijdstipAsfalt }}
                        </div>
                    </div>
                }
                <div class="data-row">
                    <div class="data-cell">Locatie</div>
                    <div class="data-cell strong">
                        {{
                            project?.location ??
                                userPlanning?.project?.location ??
                                planning?.location ??
                                planningHas?.location ??
                                planningHas?.project?.location ??
                                '-'
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    @if (!isTransport) {
        <div class="section bg-light">
            <div class="container-xl">
                <div class="data">
                    <div class="data-row">
                        <div class="data-cell">Projectleider</div>
                        <div class="data-cell strong">
                            {{
                                planning?.projectmanager_user?.name ??
                                    project?.projectmanager?.name ??
                                    userPlanning?.project?.projectmanager?.name ??
                                    planningHas?.project?.projectmanager?.name ??
                                    '-'
                            }}
                        </div>
                    </div>
                    <div class="data-row">
                        <div class="data-cell">{{ environment.executorName }}</div>
                        <div class="data-cell strong">
                            {{
                                planning?.performer_user?.name ??
                                    project?.performer?.name ??
                                    userPlanning?.project?.performer?.name ??
                                    planningHas?.performer?.name ??
                                    '-'
                            }}
                        </div>
                    </div>
                    @if (
                        planning?.asphalt_performer_user?.name ||
                        project?.asphalt_performer?.name ||
                        userPlanning?.project?.asphalt_performer?.name
                    ) {
                        <div class="data-row">
                            <div class="data-cell">Asfaltuitvoerder</div>
                            <div class="data-cell strong">
                                {{
                                    planning?.asphalt_performer_user?.name ??
                                        project?.asphalt_performer?.name ??
                                        userPlanning?.project?.asphalt_performer?.name
                                }}
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="section bg-white">
            <div class="container-xl">
                <h2>Omschrijving project</h2>
                <div
                    [innerHTML]="
                        planning?.description ?? planning?.comment ?? planningHas?.comment ?? '-' | nl2br
                    "></div>
            </div>
        </div>
    }

    @if (planning?.data) {
        <div class="section bg-light">
            <div class="container-xl">
                <h2>Overige informatie</h2>
                <div class="data">
                    <div class="data-row">
                        <div class="data-cell">Mallen</div>
                        <div class="data-cell strong">{{ planning | planningFieldValue: 'mallen' }}</div>
                    </div>
                    <div class="data-row">
                        <div class="data-cell">Opmeten</div>
                        <div class="data-cell strong">{{ planning | planningFieldValue: 'opmeten' }}</div>
                    </div>
                    <div class="data-row">
                        <div class="data-cell">Uitzetten</div>
                        <div class="data-cell strong">{{ planning | planningFieldValue: 'uitzetten' }}</div>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (materials?.length) {
        <div class="section bg-white">
            <div class="container-xl">
                <table class="materials">
                    <tr>
                        <th>Materiaal</th>
                        <th>Kleur</th>
                        <th>Dikte (mm)</th>
                        <th>Verbruik (kg/m²)</th>
                        <th>Hoeveelheid (kg)</th>
                    </tr>
                    @for (material of materials; track material; let odd = $odd) {
                        <tr [class.odd]="odd">
                            <td>{{ material | materialProperty: 'name' }}</td>
                            <td>{{ material | materialProperty: 'colorName' }}</td>
                            <td>{{ material | materialProperty: 'thickness' }}</td>
                            <td>{{ material | materialProperty: 'consumption' }}</td>
                            <td>{{ material.quantity | number: '0.0-3' }}</td>
                        </tr>
                        @for (rawMaterial of material | nonMainRawMaterials; track rawMaterial.id) {
                            <tr class="sub-row" [class.odd]="odd">
                                <td class="sub-row__name">
                                    -
                                    {{ rawMaterial | materialProperty: 'typeName' : rawMaterial.material_type?.name }}
                                </td>
                                <td></td>
                                <td>{{ rawMaterial.certificate_number }}</td>
                                <td>{{ rawMaterial.thickness }}</td>
                                <td>{{ rawMaterial.consumption }} {{ rawMaterial.consumption_type?.name }}</td>
                                <td></td>
                            </tr>
                        }
                    }
                </table>
            </div>
        </div>
    }

    @let planningFiles = planning?.planning_files;
    @if (!isTransport && planningFiles?.length) {
        <div class="section bg-white">
            <div class="container-xl">
                <h3>Bijlages</h3>

                <table>
                    <tr>
                        <th class="icon-col"></th>
                        <th>Bestand</th>
                        <th>Toegevoegd op</th>
                    </tr>

                    @for (file of planningFiles; track file; let odd = $odd) {
                        @if (file?.name) {
                            <tr [class.odd]="odd">
                                <td class="icon-col">
                                    <a (click)="downloadFile(file)">
                                        <mat-icon fontSet="fa-regular" fontIcon="fa-file-arrow-down"></mat-icon>
                                    </a>
                                </td>
                                <td>
                                    <a (click)="openFile(file)">
                                        {{ file.name }}
                                    </a>
                                </td>
                                <td class="time">
                                    {{ file.created_at | date: 'EEEE d MMM yyyy HH:mm' }}
                                </td>
                            </tr>
                        }
                    }
                </table>
            </div>
        </div>
    }

    @if (planningHas?.transport_destination) {
        <div class="section bg-light">
            <div class="container-xl">
                <h2>Locatie transport</h2>
                @if (planningHas.transport_origin !== 'none') {
                    Start:
                    {{ planningHas.transport_origin ?? '-' | replaceIf: 'next' : 'Zie vorige regel' }}<br />
                }
                @if (planningHas.transport_worksite?.length) {
                    <span> Werk: {{ planningHas.transport_worksite }}<br /> </span>
                }
                @if (planningHas.transport_destination !== 'none') {
                    Einde:
                    {{ planningHas.transport_destination | replaceIf: 'next' : 'Zie volgende regel' }}
                }
            </div>
        </div>
    }

    @if (planningHas?.comment?.length) {
        <div class="section bg-white">
            <div class="container-xl">
                <h2>Omschrijving transportbeweging</h2>
                <h3>{{ planningHas.entity?.name }}</h3>
                <div>{{ planningHas.comment }}</div>
            </div>
        </div>
    }

    @if (planning?.planning_has_all?.length || planning?.user_planning?.length) {
        <div class="section bg-light">
            <div class="container-xl">
                <h2>Met wie werk ik?</h2>
                @if (!showWorkWith) {
                    <p>Zichtbaar vanaf {{ showWorkWithFrom | date: 'EEEE d MMMM yyyy' }}</p>
                } @else {
                    <table>
                        <tr>
                            <th>Naam <span class="d-sm-none"> & materieel</span></th>
                            <th class="d-none d-sm-block">Materieel</th>
                            <th>Werktijd</th>
                            <th class="d-none d-sm-block">
                                {{ environment.executorName }}
                            </th>
                        </tr>
                        @for (planningHasAll of planning?.planning_has_all; track planningHasAll.id) {
                            @if (
                                Utils.dateString(planningHasAll?.begindate) === dateString &&
                                planningHasAll?.driver_user?.name
                            ) {
                                <tr>
                                    <td>
                                        {{ planningHasAll.driver_user.name }}
                                        <div class="d-sm-none">
                                            <i>{{ planningHasAll?.entity?.name }}</i
                                            ><br />
                                            <b>{{ environment.executorName }}:</b>
                                            {{ planningHasAll.performer?.name ?? '-' }}
                                        </div>
                                    </td>
                                    <td class="d-none d-sm-block">
                                        {{ planningHasAll?.entity?.name }}
                                    </td>
                                    <td class="time">
                                        {{ planningHasAll?.begindate | date: 'HH:mm' }} -
                                        {{ planningHasAll?.enddate | date: 'HH:mm' }}
                                    </td>
                                    <td class="d-none d-sm-block">
                                        {{ planningHasAll.performer?.name ?? '-' }}
                                    </td>
                                </tr>
                            }
                        }

                        @for (colleagueUserPlanning of planning?.user_planning; track colleagueUserPlanning) {
                            @if (
                                Utils.dateString(colleagueUserPlanning?.begindate) === dateString &&
                                colleagueUserPlanning?.user?.name
                            ) {
                                <tr>
                                    <td>
                                        {{ colleagueUserPlanning.user.name }}
                                    </td>
                                    <td class="d-none d-sm-block"></td>
                                    <td class="time">
                                        {{ colleagueUserPlanning?.begindate | date: 'HH:mm' }} -
                                        {{ colleagueUserPlanning?.enddate | date: 'HH:mm' }}
                                    </td>
                                    <td class="d-none d-sm-block">
                                        {{
                                            planning?.performer_user?.name ??
                                                (project || userPlanning?.project)?.performer?.name ??
                                                '-'
                                        }}
                                        @if (planning?.asphalt_performer_user) {
                                            / {{ planning.asphalt_performer_user.name }}
                                        }
                                    </td>
                                </tr>
                            }
                        }
                    </table>
                }
            </div>
        </div>
    }
</div>
